import React from "react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount } from "wagmi";
import { slicedAddress } from "../../helpers/helpers";
import Button from "../button/Button";

export const CustomConnectButton = ({ variant }) => {

    const { address } = useAccount();
    const displayName = slicedAddress(address);

    return (
        <ConnectButton.Custom>
            {({
                account,
                chain,
                openAccountModal,
                openChainModal,
                openConnectModal,
                authenticationStatus,
                mounted,
            }) => {
                const ready = mounted && authenticationStatus !== "loading";
                const connected = ready && account && chain && (!authenticationStatus || authenticationStatus === "authenticated");

                return (
                    <div
                        {...(!ready && {
                            "aria-hidden": true,
                            style: {
                                opacity: 0,
                                pointerEvents: "none",
                                userSelect: "none",
                            },
                        })}
                    >
                        {(() => {
                            if (!connected) {
                                return (
                                    <Button
                                        variant={variant}
                                        onClick={openConnectModal}
                                    >
                                        Connect wallet
                                    </Button>
                                );
                            } else if (chain.unsupported) {
                                return (
                                    <Button
                                        onClick={openChainModal}
                                        className="animate-pulse"
                                        variant="warning-button"
                                    >
                                        Wrong network
                                    </Button>
                                );
                            } else {
                                return (
                                    <div style={{ display: "flex", gap: 12 }}>
                                        <Button
                                            variant={variant}
                                            onClick={openAccountModal}
                                            fontColor="flex items-center gap-3 justify-center"
                                        >

                                            {chain.iconUrl && (
                                                <img
                                                    alt={chain.name ?? 'Chain icon'}
                                                    src={chain.iconUrl}
                                                    style={{ width: 20, height: 20 }}
                                                />
                                            )}{displayName}
                                        </Button>
                                    </div>
                                );
                            }
                        })()}
                    </div>
                );
            }}
        </ConnectButton.Custom>
    );
};